import SilentWitnessImageItem from './SilentWitnessImageItem';

const imageGridClasses = 'grid grid-cols-12 gap-3';
const imageGridItemClasses = 'col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-3';

const SilentWitnessImageGroup = ({ group }) => {
  return (
    <div className={imageGridClasses}>
      {group.items.map((item) => (
        <div
          key={`${group.key}-${item.index}`}
          className={imageGridItemClasses}
        >
          <SilentWitnessImageItem
            item={item}
            groupKey={group.key}
          />
        </div>
      ))}
    </div>
  );
};

export default SilentWitnessImageGroup;
